import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Sortable from 'sortablejs';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import Api from '../utils/Api';
import CardTemplateEditorModal from '../modal/CardTemplateEditorModal';
// v0.6.6 — 课程分类 / 类型 chip 渲染依赖 LessonOptions
import LessonOptions from '../utils/LessonOptions';
// v0.10.13 — 背景图 URL 转义统一入口 (见 CardBackground.escapeCssUrl 顶部注释)
// v0.17.4c — 另引入 withBuiltinVersion: 内置图渲染 URL 要带 ?v=2 破 7 天 immutable 缓存。
//   只借它加版本戳, 不借 cardBackgroundStyle() 的整串 style (那会把本页的 center 42% 抹成 center)。
import { escapeCssUrl, withBuiltinVersion } from '../utils/CardBackground';

// v0.8.0 — COLOR_OPTIONS 不再用于前端渲染 (辉哥 10/6 拍板, 颜色字段保留不删但脱渲染)
// 保留常量供 .JSZ 编 elsewhere import 用, 此处 view() 已不再 map colorKey
// eslint-disable-next-line no-unused-vars
const COLOR_OPTIONS = [{
  key: 'blue',
  hex: '#2D7BE5'
}, {
  key: 'red',
  hex: '#ff6b6b'
}, {
  key: 'orange',
  hex: '#f59e0b'
}, {
  key: 'green',
  hex: '#10b981'
}, {
  key: 'purple',
  hex: '#8b5cf6'
}, {
  key: 'pink',
  hex: '#ec4899'
}, {
  key: 'teal',
  hex: '#14b8a6'
}, {
  key: 'gray',
  hex: '#6b7280'
}];
export default class CardTemplatesTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.cards = [];
    this.loading = true;
    this.search = '';
    this.statusFilter = 'all';
    this.activeSchoolId = vnode.attrs.activeSchoolId;
    this.schools = vnode.attrs.schools || [];
    this.sortableDesktop = null;
    this.sortableMobile = null;
    LessonOptions.load();
    this.load();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (vnode.attrs.activeSchoolId !== this.activeSchoolId) {
      this.activeSchoolId = vnode.attrs.activeSchoolId;
      this.schools = vnode.attrs.schools || [];
      this.destroySortables();
      this.load();
    } else {
      this.schools = vnode.attrs.schools || [];
    }
  }
  async load() {
    try {
      this.loading = true;
      m.redraw();
      const params = this.activeSchoolId ? {
        school_id: this.activeSchoolId
      } : {};
      const r = await Api.list('card-templates', params);
      this.cards = r || [];
    } catch (e) {
      console.error('load card-templates failed', e);
    } finally {
      this.loading = false;
      m.redraw();
      this.rebuildSortables();
    }
  }
  async onReorderEnd(evt, mode) {
    if (evt.oldIndex === evt.newIndex) return;
    if (evt.oldIndex == null || evt.newIndex == null) return;
    const [moved] = this.cards.splice(evt.oldIndex, 1);
    this.cards.splice(evt.newIndex, 0, moved);
    m.redraw();
    const ids = this.cards.map(c => c.id);
    const params = this.activeSchoolId ? {
      school_id: this.activeSchoolId
    } : {};
    try {
      // v0.8.10 — 删掉 const r: 这个返回值原来只喂 console 的 log 调用, 日志删了之后没人用了
      await Api.reorder('card-templates', ids, params);
    } catch (e) {
      console.error('[CardTemplates] reorder failed, reverting', e);
      const [back] = this.cards.splice(evt.newIndex, 1);
      this.cards.splice(evt.oldIndex, 0, back);
      m.redraw();
    }
  }
  rebuildSortables() {
    this.destroySortables();
    if (!this.cards || this.cards.length < 2) return;
    let attempts = 0;
    const tryMount = () => {
      attempts++;
      const desktopEl = document.querySelector('.ZS-card-grid');
      if (desktopEl && !this.sortableDesktop) {
        this.sortableDesktop = Sortable.create(desktopEl, {
          animation: 150,
          handle: '.ZS-drag-handle',
          ghostClass: 'ZS-sortable-ghost',
          dragClass: 'ZS-sortable-drag',
          onEnd: evt => this.onReorderEnd(evt, 'desktop')
        });
      }
      const mobileEl = document.querySelector('.ZS-card-list-mobile');
      if (mobileEl && !this.sortableMobile) {
        this.sortableMobile = Sortable.create(mobileEl, {
          animation: 150,
          handle: '.ZS-drag-handle',
          ghostClass: 'ZS-sortable-ghost',
          dragClass: 'ZS-sortable-drag',
          onEnd: evt => this.onReorderEnd(evt, 'mobile')
        });
      }
      if (!desktopEl && attempts < 15) setTimeout(tryMount, 100);
    };
    setTimeout(tryMount, 0);
  }
  destroySortables() {
    if (this.sortableDesktop) {
      try {
        this.sortableDesktop.destroy();
      } catch (e) {}
      this.sortableDesktop = null;
    }
    if (this.sortableMobile) {
      try {
        this.sortableMobile.destroy();
      } catch (e) {}
      this.sortableMobile = null;
    }
  }
  onremove() {
    this.destroySortables();
  }
  filteredCards() {
    let list = this.cards;
    if (this.search) {
      const q = this.search.toLowerCase();
      list = list.filter(c => (c.name || '').toLowerCase().includes(q) || (c.desc || '').toLowerCase().includes(q));
    }
    if (this.statusFilter !== 'all') {
      list = list.filter(c => c.status === this.statusFilter);
    }
    return list;
  }
  openEditor(card) {
    app.modal.show(CardTemplateEditorModal, {
      card: card || null,
      onClose: () => this.load()
    });
  }
  async remove(card) {
    if (!confirm('确认删除卡种 "' + card.name + '"?')) return;
    await Api.delete('card-templates', card.id);
    await this.load();
  }

  // v0.8.0 — 拖拽手柄 (深色背景上要浅色字)
  dragHandle() {
    return m("span", {
      className: "ZS-drag-handle",
      title: "\u62D6\u52A8\u6392\u5E8F"
    }, "\u22EE\u22EE");
  }

  // v0.8.0 — inline style 把 bg_image URL 注入到 background-image
  //   没有 bg_image 时, background-color 由 LESS 兜底 (#1b1f26)
  //
  // v0.17.4c — 内置图补 `?v=2` 版本戳 (换图破 7 天 immutable 缓存)。
  //
  // ⚠️ 为什么**不**直接用共享的 cardBackgroundStyle():
  //   共享函数返回的整串 style 里 background-position 是 `center` (= 50% 50%),
  //   而**这一页要的是 `center 42%`** (v0.8.0 设计: 卡片主体偏下, 让上方留白给卡名)。
  //   直接套用会把 42% 抹成 50% ⇒ 图整体下移, 是观感回归。
  //   所以这里只借共享模块的 **withBuiltinVersion()** 给 URL 加戳,
  //   background-position / background-size 仍由本函数自己原样输出。
  //
  // withBuiltinVersion() 的行为 (见 CardBackground.js):
  //   - 路径含 /api/ziiven/scheduler/card-bg/ 的内置图 → 末尾加 ?v=2 (幂等, 已带则替换)
  //   - 其它 URL (用户自定义 COS 图, 含预签名 query) → **原样返回, 一个字符都不动**
  cardBackgroundStyle(card) {
    if (card.bg_image) {
      // v0.17.4c — 版本戳先加, 再走共享 escapeCssUrl (先 '\' 后 '"' + 剥控制字符)
      const url = withBuiltinVersion(card.bg_image);
      return 'background-image: url("' + escapeCssUrl(url) + '"); background-position: center 42%; background-size: cover;';
    }
    return '';
  }

  // v0.50n — 预先解构每张卡, desktop / mobile 两边共用
  //   v0.8.0: 去掉 colorKey (颜色字段不再渲染), 只剩 disabled
  view() {
    const list = this.filteredCards();
    const cardData = list.map(card => {
      const disabled = card.status === 'disabled';
      return {
        card,
        disabled
      };
    });
    return m("div", null, m("div", {
      className: "ZS-toolbar ZS-card-toolbar"
    }, m(Dropdown, {
      buttonClassName: "ZS-filter-dropdown-btn",
      icon: "fas fa-filter",
      label: this.statusFilter === 'all' ? app.translator.trans('ziven-scheduler.forum.card-templates.filter-status-all') : this.statusFilter === 'enabled' ? app.translator.trans('ziven-scheduler.forum.card-templates.filter-status-enabled') : app.translator.trans('ziven-scheduler.forum.card-templates.filter-status-disabled')
    }, m(Button, {
      active: this.statusFilter === 'all',
      onclick: () => {
        this.statusFilter = 'all';
        m.redraw();
      }
    }, app.translator.trans('ziven-scheduler.forum.card-templates.filter-status-all')), m(Button, {
      active: this.statusFilter === 'enabled',
      onclick: () => {
        this.statusFilter = 'enabled';
        m.redraw();
      }
    }, app.translator.trans('ziven-scheduler.forum.card-templates.filter-status-enabled')), m(Button, {
      active: this.statusFilter === 'disabled',
      onclick: () => {
        this.statusFilter = 'disabled';
        m.redraw();
      }
    }, app.translator.trans('ziven-scheduler.forum.card-templates.filter-status-disabled'))), m("button", {
      className: "ZS-btn",
      onclick: () => this.openEditor(null)
    }, "+ \u65B0\u5EFA\u5361\u7247")), this.loading ? m("div", {
      style: "padding:60px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u52A0\u8F7D\u4E2D...") : m("div", null, m("div", {
      className: "ZS-card-grid"
    }, cardData.map(_ref => {
      let {
        card,
        disabled
      } = _ref;
      return m("div", {
        className: 'ZS-card-tpl' + (disabled ? ' disabled' : '') + (card.bg_image ? ' has-bg' : ''),
        key: card.id,
        style: this.cardBackgroundStyle(card)
      }, this.dragHandle(), m("div", {
        className: "ZS-card-tpl-info"
      }, m("div", {
        className: "ZS-card-tpl-name"
      }, card.name), m("div", {
        className: "ZS-card-tpl-desc"
      }, card.desc || '—'), m("div", {
        className: "ZS-card-tpl-meta"
      }, m("span", null, m("span", {
        className: "ZS-meta-price"
      }, "\xA5", card.price)), m("span", null, m("i", {
        className: "fas fa-book",
        style: "color:var(--zs-info-67e8f9, #67e8f9);margin-right:4px;"
      }), m("span", {
        className: "ZS-meta-text-green"
      }, card.lessons, " \u8BFE\u65F6")), m("span", null, m("i", {
        className: "fas fa-stopwatch",
        style: "color:var(--zs-warning-fde047, #fde047);margin-right:4px;"
      }), m("span", {
        className: "ZS-meta-text-blue"
      }, card.minutes, " \u5206\u949F")), m("span", null, m("i", {
        className: "fas fa-users",
        style: "color:var(--zs-info-93c5fd, #93c5fd);margin-right:4px;"
      }), m("span", {
        style: "color:var(--zs-text-1-soft-255-255-255-82, rgba(255,255,255,.82));"
      }, "\u5DF2\u7ED1\u5B9A ", card.bound_count, " \u4EBA"))), m("div", {
        className: "ZS-card-tpl-tagline"
      }, m("div", {
        className: "ZS-tagline-group"
      }, m("span", {
        className: "ZS-tagline-label"
      }, app.translator.trans('ziven-scheduler.forum.card-templates.tagline-type')), card.lesson_type_id ? m("span", {
        className: "ZS-type-tag"
      }, m("i", {
        className: "fas fa-tag",
        style: "color:var(--zs-success-22c55e, #22c55e);margin-right:3px;"
      }), LessonOptions.labelFor('type', card.lesson_type_id)) : m("span", {
        className: "ZS-tagline-fb"
      }, m("i", {
        className: "fas fa-tag",
        style: "color:var(--zs-text-2-soft-255-255-255-30, rgba(255,255,255,.30));margin-right:3px;"
      }), app.translator.trans('ziven-scheduler.forum.card-templates.fallback-no-type'))), m("span", {
        className: "ZS-tagline-divider"
      }, "|"), m("div", {
        className: "ZS-tagline-group"
      }, m("span", {
        className: "ZS-tagline-label"
      }, app.translator.trans('ziven-scheduler.forum.card-templates.tagline-category')), m("div", {
        className: "ZS-tagline-chips"
      }, (card.lesson_category_ids || []).length > 0 ? card.lesson_category_ids.map(cid => m("span", {
        key: 'cat-' + cid,
        className: "ZS-category-tag"
      }, m("i", {
        className: "fas fa-bookmark",
        style: "color:var(--zs-purple, #8b5cf6);margin-right:3px;"
      }), LessonOptions.labelFor('category', cid))) : m("span", {
        className: "ZS-tagline-fb"
      }, m("i", {
        className: "fas fa-bookmark",
        style: "color:var(--zs-text-2-soft-255-255-255-30, rgba(255,255,255,.30));margin-right:3px;"
      }), app.translator.trans('ziven-scheduler.forum.card-templates.fallback-no-category'))))), m("div", {
        className: "ZS-card-tpl-actions"
      }, m("button", {
        className: "ZS-btn",
        style: "padding:3px 11px;font-size:11.5px;",
        onclick: () => this.openEditor(card)
      }, "\u7F16\u8F91"), m("button", {
        className: "ZS-btn",
        style: "padding:3px 11px;font-size:11.5px;color:var(--zs-btn-danger-fg-ffd9d6, #ffd9d6);background:var(--zs-danger-soft-255-59-48-20, rgba(255,59,48,.20));border-color:var(--zs-danger-soft-255-59-48-45, rgba(255,59,48,.45));",
        onclick: () => this.remove(card)
      }, "\u5220\u9664"), m("span", {
        className: "ZS-actions-spacer"
      }), m("span", {
        className: "ZS-switch-label"
      }, disabled ? '停用' : '启用'), m(Switch, {
        state: !disabled,
        onchange: checked => {
          const newStatus = checked ? 'enabled' : 'disabled';
          Api.update('card-templates', card.id, {
            status: newStatus
          }).then(() => {
            const idx = this.cards.findIndex(c => c.id === card.id);
            if (idx >= 0) {
              this.cards[idx].status = newStatus;
              m.redraw();
            }
          }).catch(e => {
            console.error('[CardTemplates] Switch update failed', e);
          });
        }
      }))));
    })), m("div", {
      className: "ZS-card-list-mobile"
    }, cardData.map(_ref2 => {
      let {
        card,
        disabled
      } = _ref2;
      return m("div", {
        className: 'ZS-card-tpl-mobile' + (disabled ? ' disabled' : '') + (card.bg_image ? ' has-bg' : ''),
        key: 'm-' + card.id,
        style: this.cardBackgroundStyle(card)
      }, this.dragHandle(), m("div", {
        className: "ZS-card-tpl-info-mobile"
      }, m("div", {
        className: "ZS-card-tpl-name"
      }, card.name), m("div", {
        className: "ZS-card-tpl-desc"
      }, card.desc || '—'), m("div", {
        className: "ZS-card-tpl-meta-mobile"
      }, m("span", null, m("span", {
        className: "ZS-price-big"
      }, "\xA5", card.price)), m("span", null, m("i", {
        className: "fas fa-book",
        style: "color:var(--zs-info-67e8f9, #67e8f9);margin-right:4px;"
      }), m("span", {
        className: "ZS-meta-text-mini ZS-meta-green"
      }, card.lessons, " \u8BFE\u65F6")), m("span", null, m("i", {
        className: "fas fa-stopwatch",
        style: "color:var(--zs-warning-fde047, #fde047);margin-right:4px;"
      }), m("span", {
        className: "ZS-meta-text-mini ZS-meta-blue"
      }, card.minutes, " \u5206\u949F")), m("span", null, m("i", {
        className: "fas fa-users",
        style: "color:var(--zs-info-93c5fd, #93c5fd);margin-right:4px;"
      }), m("span", {
        className: "ZS-meta-text-mini"
      }, "\u5DF2\u7ED1\u5B9A ", card.bound_count, " \u4EBA"))), m("div", {
        className: "ZS-card-tpl-tagline"
      }, m("div", {
        className: "ZS-tagline-group"
      }, m("span", {
        className: "ZS-tagline-label"
      }, app.translator.trans('ziven-scheduler.forum.card-templates.tagline-type')), card.lesson_type_id ? m("span", {
        className: "ZS-type-tag"
      }, m("i", {
        className: "fas fa-tag",
        style: "color:var(--zs-success-22c55e, #22c55e);margin-right:3px;"
      }), LessonOptions.labelFor('type', card.lesson_type_id)) : m("span", {
        className: "ZS-tagline-fb"
      }, m("i", {
        className: "fas fa-tag",
        style: "color:var(--zs-text-2-soft-255-255-255-30, rgba(255,255,255,.30));margin-right:3px;"
      }), app.translator.trans('ziven-scheduler.forum.card-templates.fallback-no-type'))), m("span", {
        className: "ZS-tagline-divider"
      }, "|"), m("div", {
        className: "ZS-tagline-group"
      }, m("span", {
        className: "ZS-tagline-label"
      }, app.translator.trans('ziven-scheduler.forum.card-templates.tagline-category')), m("div", {
        className: "ZS-tagline-chips"
      }, (card.lesson_category_ids || []).length > 0 ? card.lesson_category_ids.map(cid => m("span", {
        key: 'cat-' + cid,
        className: "ZS-category-tag"
      }, m("i", {
        className: "fas fa-bookmark",
        style: "color:var(--zs-purple, #8b5cf6);margin-right:3px;"
      }), LessonOptions.labelFor('category', cid))) : m("span", {
        className: "ZS-tagline-fb"
      }, m("i", {
        className: "fas fa-bookmark",
        style: "color:var(--zs-text-2-soft-255-255-255-30, rgba(255,255,255,.30));margin-right:3px;"
      }), app.translator.trans('ziven-scheduler.forum.card-templates.fallback-no-category'))))), m("div", {
        className: "ZS-card-tpl-actions"
      }, m("button", {
        className: "ZS-btn-mini",
        onclick: () => this.openEditor(card)
      }, "\u7F16\u8F91"), m("button", {
        className: "ZS-btn-mini ZS-btn-mini-danger",
        onclick: () => this.remove(card)
      }, "\u5220\u9664"), m("span", {
        className: "ZS-actions-spacer"
      }), m("span", {
        className: "ZS-switch-label"
      }, disabled ? '停用' : '启用'), m(Switch, {
        state: !disabled,
        onchange: checked => {
          const newStatus = checked ? 'enabled' : 'disabled';
          Api.update('card-templates', card.id, {
            status: newStatus
          }).then(() => {
            const idx = this.cards.findIndex(c => c.id === card.id);
            if (idx >= 0) {
              this.cards[idx].status = newStatus;
              m.redraw();
            }
          }).catch(e => {
            console.error('[CardTemplates] Switch update failed', e);
          });
        }
      }))));
    }))));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/components/CardTemplatesTab', CardTemplatesTab);